import { Button } from "../button";


interface SaveButtonProps {
  label?: string;
  disabled?: boolean;
  handleSave: () => void;
}

export function SaveButton({
  label = "Save",
  disabled = false,
  handleSave,
  ...buttonProps
}: SaveButtonProps) {
  return (
    <Button
      variant="default"
      size="sm"
      color="primary"
      {...buttonProps}
      onClick={handleSave}
      disabled={disabled}
    >
      {label}
    </Button>
  );
}
